import encodeChars from './encodeChars';

export default {
  multiple: true,
  encode(data, {name}) {
    const baseKey = encodeChars.colon(name);
    const baseVal = data.value;
    const results = [];
    if (baseVal.from) {
      results.push([`${baseKey}-min`, baseVal.from]);
    }
    if (baseVal.to) {
      results.push([`${baseKey}-max`, baseVal.to]);
    }
    return results;
  },
  decode(values, {settings}) {
    return {
      type: settings.type,
      value: values,
    };
  },
};
